import { all, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';
// redux actions
import {
	DELETE_ATTACH,
	DOWNLOAD_ATTACH,
	GET_CONST_VALUE,
	GET_CUSTOMER_DATA,
	GET_DASHBOARD_DATA,
	GET_DASHBOARD_OFFERS,
	GET_OFFER,
	GET_OFFERS_ALL,
	GET_OFFERS_SEARCH,
	// GET_OPPORTUNITIES,
	OFFER_CALCULATE,
	OFFER_CLEAR_ERROR,
	OFFER_SAVE,
	OFFER_UPDATE,
	// SEND_PROPOSAL,
	UNLOCK_OFFER,
	UPLOAD_ATTACH
} from './actionTypes';
import {
	customerDataSet,
	fileDownloadSuccess,
	offerCalculateSuccess,
	offerClearError,
	offerError,
	setChartOffers,
	setOffer,
	setOffers
} from './actions';
// Api methods
import { api } from 'api';
// interface
import { AxiosResponse } from 'axios';
import {
	CalcType,
	CalculationReq,
	CalculationRes,
	Constant,
	Customer,
	FilterDuration,
	Offer,
	OfferSearch,
	OfferState,
	OfferStage,
	SaveRes,
	SaveStatus
} from 'api';
import i18n from '../../i18n';
import { mapOfferToCalculationRes } from '../../utils/mappers';
import { apiLoading, apiResError, apiResInfo, apiResSuccess } from '../actions';
import { isDefined } from '../../utils/Functions';
import { setConstValue } from '../calculator/actions';

export interface ICustomerDataPayload {
	ident: string;
	value: string;
	calcType?: CalcType;
	isAquisition?: boolean;
}

export interface ICustomerGetPayload {
	payload: ICustomerDataPayload;
	type: string;
}

export interface IOfferSearchPayload {
	payload?: OfferSearch;
	type: string;
}

export interface IOfferSavePayload {
	payload: {
		offer: Offer;
		files: any[];
	};
	type: string;
}
export interface IOfferCaluclatePayload {
	payload: CalculationReq;
	type: string;
}

export interface IVpnOfferCaluclatePayload {
	payload: Offer;
	type: string;
}

export interface IOfferUnlockPayload {
	id: number;
	type: string;
}

export interface IUploadAttachPayload {
	offerId: number;
	payload: any;
	type: string;
}

export interface IAttachPayload {
	offerId: number;
	payload: number; //attachId
	type: string;
}

export interface IGetDashboardOffers {
	payload: {
		offerID: number | undefined;
		offerType: CalcType | undefined;
		portfolioID: number | undefined;
		user: string | undefined;
		regionalManager: string | undefined;
		state: OfferState | undefined;
		status: OfferStage | undefined;
		duration: FilterDuration;
	};
	type: string;
}

export interface IGetConstByNamePayload {
	payload: string;
	type: string;
}

function* getOffer({ payload }: any) {
	// ID
	yield put(apiLoading('Loading offer'));
	try {
		const response: AxiosResponse<Offer> = yield api.offer.apiOfferDataIdGet(payload);
		const calculation = mapOfferToCalculationRes(response.data);
		if (response.data !== null) {
			yield put(setOffer(response.data));
			yield put(offerCalculateSuccess(calculation));
			yield put(apiResSuccess('Loading done'));
		} else {
			yield put(apiResError('Offer load failed'));
		}
	} catch (error: any) {
		console.log('OFFER GET ERROR', error);
		yield put(offerError(error));
	}
}

function* getOffers() {
	try {
		const response: AxiosResponse<Offer[]> = yield api.offer.apiOfferDataGet();

		yield put(setOffers(response.data));
	} catch (error: any) {
		yield put(offerError(error));
	}
}

function* getDashboardOffers({ payload }: IGetDashboardOffers) {
	yield put(apiLoading('Loading dashboard data'));
	try {
		const response: AxiosResponse<Offer[]> =
			yield api.offer.apiOfferDataGetDashboardDataPost(payload);

		yield put(apiResSuccess('Dashboard data loaded'));
		yield put(setOffers(response.data));
	} catch (error: any) {
		yield put(apiResError('Error when loading dashboard data'));
		yield put(offerError(error));
	}
}

function* getDashboardData({ payload }: IGetDashboardOffers) {
	yield put(apiLoading('Loading dashboard data'));

	try {
		const response: AxiosResponse<Offer[]> =
			yield api.offer.apiOfferDataGetDashboardDataPost(payload);

		yield put(setChartOffers(response.data));
		yield put(setOffers(response.data));
		yield put(apiResSuccess('Dashboard data loaded'));
	} catch (error: any) {
		yield put(apiResError('Error when loading dashboard data'));
		yield put(offerError(error));
	}
}

function* updateOffer({ payload }: IOfferSavePayload) {
	yield put(apiLoading('Updating offer'));
	try {
		const id = Number(payload.offer.id);

		const response: AxiosResponse<SaveRes> = yield api.offer.apiOfferDataIdPut(
			id,
			payload.offer
		);
		if (response.data.status === SaveStatus.Success) {
			const offerId = Number(response.data.createdId);
			const offerRes: AxiosResponse<Offer> = yield api.offer.apiOfferDataIdGet(offerId);

			if (payload.files.length > 0) {
				for (var i = 0; i < payload.files.length; i++) {
					const offerAttach: any = payload.files[i];

					const genData: IUploadAttachPayload = {
						offerId: offerId,
						payload: offerAttach,
						type: UPLOAD_ATTACH
					};

					yield uploadAttach(genData);
				}
			} else {
				yield put(setOffer(offerRes.data));
			}
		} else {
			yield put(apiResError(response.data.message || 'Save failed'));
		}
	} catch (error: any) {
		yield put(apiResError(error.message || 'Error saving offer'));
	}
}

function* saveOffer({ payload }: IOfferSavePayload) {
	yield put(apiLoading('Saving offer'));
	try {
		const response: AxiosResponse<SaveRes> = yield api.offer.apiOfferDataPost(payload.offer);

		if (response.data.status === SaveStatus.Success) {
			const offerId = Number(response.data.createdId);
			const offerRes: AxiosResponse<Offer> = yield api.offer.apiOfferDataIdGet(offerId);

			yield put(apiResSuccess(response.data.message || 'Save successfull'));

			if (payload.files.length > 0) {
				for (var i = 0; i < payload.files.length; i++) {
					const offerAttach: any = payload.files[i];

					const genData: IUploadAttachPayload = {
						offerId: offerId,
						payload: offerAttach,
						type: UPLOAD_ATTACH
					};

					yield uploadAttach(genData);
				}
			} else {
				yield put(setOffer(offerRes.data));
			}
		} else {
			yield put(apiResError(response.data.message || 'Save failed'));
		}
	} catch (error: any) {
		yield put(apiResError(error.message || 'Error saving offer'));
	}
}

function* calculateOffer({ payload }: IOfferCaluclatePayload) {
	yield put(apiLoading('Calculation started'));
	try {
		const response: AxiosResponse<CalculationRes> =
			yield api.calculation.apiCalculationDataOfferTestPost(payload);
		yield put(apiResSuccess('Calculation done'));
		yield put(offerCalculateSuccess(response.data));
	} catch (error: any) {
		yield put(apiResError(error.message || i18n.t('Error calculating offer')));
	}
}

// function* calculateVpnOffer({ payload }: IVpnOfferCaluclatePayload) {
// 	yield put(apiLoading('Starting calculation'));
// 	try {
// 		const response: AxiosResponse<CalculationRes> =
// 			yield api.calculation.apiCalculationDataOfferCalculationPost(
// 				payload
// 			);
// 		yield put(offerCalculateSuccess(response.data));
// 		yield put(apiResSuccess('Calculation done'));
// 	} catch (error: any) {
// 		yield put(
// 			apiResError(error.message || i18n.t('Error calculating offer'))
// 		);
// 	}
// }

function* getCustomerData({ payload }: ICustomerGetPayload) {
	try {
		const response: AxiosResponse<Customer> = yield api.customer.apiCustomerDataGet(
			payload.ident,
			payload.value
		);
		if (isDefined(response.data.companyName) && isDefined(response.data.companyId)) {
			const { data } = response;

			yield put(customerDataSet(data));
			yield put(apiResSuccess('Customer fecthed successfully'));
		} else {
			yield put(apiResInfo('No customer found'));
		}
	} catch (error: any) {
		yield put(offerError(error.message));
	}
}

function* unlockOffer({ id, type }: IOfferUnlockPayload) {
	try {
		const response: AxiosResponse<SaveRes> = yield api.offer.apiOfferDataUnlockIdPost(id);
		if (response.data.status === SaveStatus.Success) {
			yield put(apiResSuccess(response.data.message || 'Unlock successfull'));
		} else {
			yield put(apiResError(response.data.message || 'Unlock failed'));
		}
	} catch (error: any) {
		yield put(apiResError(error.message || 'Error unlocking offer'));
	}
}

function* uploadAttach({ offerId, payload }: IUploadAttachPayload) {
	const { formFile, fileName } = payload;
	yield put(apiLoading(fileName));

	try {
		const response: AxiosResponse<SaveRes> = yield api.utils.apiUtilsUploadAttachmentIdPost(
			offerId,
			fileName,
			formFile
		);
		if (response.data.status === SaveStatus.Success) {
			yield put(apiResSuccess('Upload successfull'));

			const offerRes: AxiosResponse<Offer> = yield api.offer.apiOfferDataIdGet(offerId);
			yield put(setOffer(offerRes.data));
		} else {
			yield put(apiResError(response.data.message));
		}
	} catch (error: any) {
		yield put(apiResError(error.message || 'Error uploading offer documents'));
	}
}

function* downloadAttach({ offerId, payload }: IAttachPayload) {
	yield put(apiLoading());
	try {
		const response: AxiosResponse<any> = yield api.utils.apiUtilsDownloadAttachmentIdGet(
			payload,
			offerId,
			{
				responseType: 'blob'
			}
		);
		console.log(response.data);
		if (response.data !== null) {
			const blobFile: any = {
				id: payload,
				file: response.data
			};
			yield put(fileDownloadSuccess(blobFile));
		} else {
			yield put(apiResError('Download failed'));
		}
	} catch (error: any) {
		yield put(apiResError(error.message || 'Error downloading offer document'));
	}
}

function* deleteAttach({ offerId, payload }: IAttachPayload) {
	yield put(apiLoading('Deleting document'));

	try {
		const response: AxiosResponse<SaveRes> = yield api.utils.apiUtilsDeleteAttachmentIdDelete(
			payload,
			offerId
		);
		if (response.data.status === SaveStatus.Success) {
			yield put(apiResSuccess('File deleted successfully'));

			const offerRes: AxiosResponse<Offer> = yield api.offer.apiOfferDataIdGet(offerId);
			yield put(setOffer(offerRes.data));
		} else {
			yield put(apiResError('Delete failed'));
		}
	} catch (error: any) {
		yield put(apiResError(error.message || 'Error uploading offer documents'));
	}
}

function* getOffersSearch({ payload }: IOfferSearchPayload) {
	yield put(apiLoading('Search pending'));
	try {
		const response: AxiosResponse<Offer[]> = yield api.offer.apiOfferDataSearchPost(payload);
		if (response.data) {
			yield put(apiLoading('Search finished'));
		}
		yield put(setOffers(response.data));
	} catch (error: any) {
		yield put(apiResError('Offer search error'));
		yield put(offerError(error.message));
	}
}

function* getConstValByName({ payload }: IGetConstByNamePayload) {
	try {
		const response: AxiosResponse<Constant> =
			yield api.calculation.apiCalculationDataConstantByNameGet(payload);
		if (response.data) {
			yield put(setConstValue(response.data));
		}
	} catch (error: any) {
		yield put(apiResError(error.message));
	}
}

export function* watchGetVatValue() {
	yield takeEvery(GET_CONST_VALUE, getConstValByName);
}

function* clearError() {
	yield put(offerClearError());
}
export function* watchGetOffer() {
	yield takeEvery(GET_OFFER, getOffer);
}
export function* watchSaveOffer() {
	yield takeEvery(OFFER_SAVE, saveOffer);
}
export function* watchUpdateOffer() {
	yield takeEvery(OFFER_UPDATE, updateOffer);
}
export function* watchUploadAttach() {
	yield takeEvery(UPLOAD_ATTACH, uploadAttach);
}

export function* watchDownloadAttach() {
	yield takeEvery(DOWNLOAD_ATTACH, downloadAttach);
}
export function* watchDeleteAttach() {
	yield takeEvery(DELETE_ATTACH, deleteAttach);
}

export function* watchCalculateOffer() {
	yield takeLatest(OFFER_CALCULATE, calculateOffer);
}

export function* watchGetOffers() {
	yield takeEvery(GET_OFFERS_ALL, getOffers);
}

export function* watchGetDashboardOffers() {
	yield takeEvery(GET_DASHBOARD_OFFERS, getDashboardOffers);
}

export function* watchGetDashboardData() {
	yield takeEvery(GET_DASHBOARD_DATA, getDashboardData);
}

export function* watchGetOffersSearch() {
	yield takeEvery(GET_OFFERS_SEARCH, getOffersSearch);
}

export function* watchGetCustomerData() {
	yield takeEvery(GET_CUSTOMER_DATA, getCustomerData);
}

export function* watchClearError() {
	yield takeEvery(OFFER_CLEAR_ERROR, clearError);
}

export function* watchUnlockOffer() {
	yield takeEvery(UNLOCK_OFFER, unlockOffer);
}

function* offerSearchSaga() {
	yield all([
		fork(watchGetOffer),
		fork(watchGetOffers),
		fork(watchSaveOffer),
		fork(watchUpdateOffer),
		fork(watchCalculateOffer),
		fork(watchGetOffersSearch),
		fork(watchGetCustomerData),
		fork(watchClearError),
		fork(watchUnlockOffer),
		fork(watchUploadAttach),
		fork(watchDeleteAttach),
		fork(watchDownloadAttach),
		fork(watchGetVatValue),
		fork(watchGetDashboardOffers),
		fork(watchGetDashboardData)
	]);
}

export default offerSearchSaga;
